import * as React from 'react'
import { useEffect, useState } from 'react'

import { RenderButtonEvents } from '../../atoms/Button/RenderButton'
import TextButtonWithIcon from '../../atoms/Button/Text/ButtonWithIcon'
import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'
import EventRegistrationForm from '../EventRegistrationForm'
import MoreEvents from './MoreEvents'
import { useSEO } from '../../../context/SEOContext'
import { useLocation } from 'react-router-dom'

interface Props {
  content?: any
  eventDetailsData?: any
  eventsData?: any
  buttonDetails?: any
  buttonCards?: any
}

/**
 * Event Details Component
 * @param content - Content from the CMS.
 */
const EventDetails = ({ content, eventDetailsData, eventsData, buttonDetails, buttonCards }: Props) => {
  const [moreDates, setMoreDates] = useState([])
  const [form, setForm] = useState('')
  const [evtDataForm, setEvtDataForm] = useState({})
 //SEO changes block - START
  const { setSEO } = useSEO();
  const location = useLocation();
  const baseUrl = window.location.origin;
  //SEO changes block - END

  const handleForm = (e: any, evtId: string) => {
    e.preventDefault()
    e.stopPropagation()
    setForm(evtId)
  }

  const formatDateDifferentDay = () => {
    return `${new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', {
      weekday: 'long',
    })}, ${new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', {
      day: 'numeric',
    })} ${new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', { month: 'long' })} ${new Date(
      eventDetailsData[0]?.fields?.startDate,
    ).toLocaleTimeString('default', {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
    })} - ${new Date(eventDetailsData[0]?.fields?.endDate).toLocaleDateString('default', {
      weekday: 'long',
    })}, ${new Date(eventDetailsData[0]?.fields?.endDate).toLocaleDateString('default', { day: 'numeric' })} ${new Date(
      eventDetailsData[0]?.fields?.endDate,
    ).toLocaleDateString('default', { month: 'long' })} ${new Date(
      eventDetailsData[0]?.fields?.endDate,
    ).toLocaleTimeString('default', { hour12: true, hour: 'numeric', minute: '2-digit' })}`
  }

  const formatDateSameDay = () => {
    return `${new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', {
      weekday: 'long',
    })}, ${new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', {
      day: 'numeric',
    })} ${new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', { month: 'long' })} ${new Date(
      eventDetailsData[0]?.fields?.startDate,
    ).toLocaleTimeString('default', {
      hour12: true,
      hour: 'numeric',
      minute: '2-digit',
    })} - ${new Date(eventDetailsData[0]?.fields?.endDate).toLocaleTimeString('default', {
      hour12: true,
      hour: 'numeric',
      minute: '2-digit',
    })}`
  }

  useEffect(() => {
    if (!form) return
    const targetElement: any = document.querySelector('.backToEvents')
    const top = targetElement?.offsetTop
    window.scrollTo({ top: top, behavior: 'smooth' })
  }, [form])

  useEffect(() => {
    if (!eventDetailsData || eventDetailsData.length === 0 || eventsData.length === 0) return
    if (Object.keys(eventDetailsData[0]).length === 0) return

    const evtForm = {
      ...eventDetailsData[0]?.fields,
      eventDate:
        new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', { day: 'numeric' }) !==
        new Date(eventDetailsData[0]?.fields?.endDate).toLocaleDateString('default', { day: 'numeric' })
          ? formatDateDifferentDay()
          : formatDateSameDay(),
      eventDescription: document.getElementsByClassName('evt-desc')[0]?.textContent,
    }

    setEvtDataForm(evtForm)
    const startDate = eventDetailsData[0]?.fields?.startDate

    const moreDates = eventsData?.filter(
      (item) => item !== eventDetailsData[0] && item?.fields?.startDate === startDate,
    )
    if (moreDates.length > 0) {
      setMoreDates(moreDates)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content, eventsData, eventDetailsData])

  useEffect(() => {
    const event = eventDetailsData?.[0]?.fields;
    if (event) {
      const title = `ESSSuper Event – ${event.title}`;
     // const description = `Join us for ${event.title} on ${new Date(event.startDate).toLocaleDateString()} - ESSSuper`;
    const description = `Join us for ${event.title} on ${new Date(event.startDate).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })} - ESSSuper`;
      const canonicalUrl = event?.eventId
      ? `${baseUrl}${location.pathname}?eventId=${event.eventId}`
      : `${baseUrl}${location.pathname}`;

      setSEO({
        title,
        description,
        canonicalUrl,
      });
    }
  }, [eventDetailsData]);
  
  return (
    <>
      <div id={eventDetailsData[0]?.fields?.eventId} className={`layoutSpacing w-100 bg-white`}>
        <div className="layout">
          <div className="backToEvents sectionBottomSpacing">
            <TextButtonWithIcon
              variant="dark"
              name="Back to all events"
              underline={true}
              iconPosition="start"
              arrowDirection="left"
              classes="!text-black cursor-pointer"
              link={buttonDetails?.fields.buttonLink}
            />
          </div>
          {Object.keys(eventDetailsData[0]).length !== 0 && form === '' && (
            <div className="sectionBottomSpacing">
              <div className="flex flex-col gap-32 lg:flex-row">
                <div className={`w-100 xl:w-75`}>
                  <Headings variant="H2" content={`${eventDetailsData[0]?.fields?.title}`} classes="text-purple-100" />
                  <Paragraph content={eventDetailsData[0]?.fields?.eventDescription} classes="w-100 xl:w-75 evt-desc" />
                </div>
                <div className={`shrink-0 grow lg:w-25`}>
                  <div className="flex grow flex-col gap-32">
                    <div className="flex flex-col items-start gap-8">
                      <div className="flex items-center gap-8">
                        <Image
                          imageUrl={eventDetailsData[0]?.fields?.fundTypeIcon?.fields?.file?.url}
                          altText={eventDetailsData[0]?.fields?.fundTypeIcon?.fields?.file?.title}
                          width="20"
                        />
                        <Paragraph content={eventDetailsData[0]?.fields?.fundTypeLabel} classes="!text-sm" />
                      </div>
                      <div className="flex pl-24">
                        <Paragraph content={eventDetailsData[0]?.fields?.fundTypeValue} />
                      </div>
                    </div>
                    <div className="flex flex-col items-start gap-8">
                      <div className="flex items-center gap-8">
                        <Image
                          imageUrl={eventDetailsData[0]?.fields?.presenterIcon?.fields?.file?.url}
                          altText={eventDetailsData[0]?.fields?.presenterIcon?.fields?.file?.title}
                          width="20"
                        />
                        <Paragraph content={eventDetailsData[0]?.fields?.presenterLabel} classes="!text-sm" />
                      </div>
                      <div className="flex pl-24">
                        <Paragraph content={eventDetailsData[0]?.fields?.presenterValue} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex pt-32">
                <div
                  className={`w-100 overflow-hidden rounded-2xl bg-purple-10 p-24 hover:border-purple-100 md:p-32 lg:w-75`}
                >
                  <div className="flex grow flex-col gap-32">
                    <div className="flex flex-col items-start gap-8">
                      <div className="flex items-center gap-8">
                        <Image
                          imageUrl={eventDetailsData[0]?.fields?.locationIcon?.fields?.file?.url}
                          altText={eventDetailsData[0]?.fields?.locationIcon?.fields?.file?.title}
                          width="20"
                        />
                        <Paragraph content="Location" classes="!text-sm" />
                      </div>
                      <div className="flex pl-24">
                        <Paragraph
                          content={
                            eventDetailsData[0]?.fields?.locationAddress
                              ? eventDetailsData[0]?.fields?.locationAddress
                              : 'Online'
                          }
                        />
                      </div>
                    </div>
                    <div className="flex flex-col items-start gap-8">
                      <div className="flex items-center gap-8">
                        <Image
                          imageUrl={eventDetailsData[0]?.fields?.eventCalendarIcon?.fields?.file?.url}
                          altText={eventDetailsData[0]?.fields?.eventCalendarIcon?.fields?.file?.title}
                          width="20"
                        />
                        <Paragraph content="Date" classes="!text-sm" />
                      </div>
                      <div className="flex pl-24">
                        {/* Start date and end is different day */}
                        {new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', {
                          day: 'numeric',
                        }) !==
                          new Date(eventDetailsData[0]?.fields?.endDate).toLocaleDateString('default', {
                            day: 'numeric',
                          }) && <Paragraph content={formatDateDifferentDay()} />}
                        {/* Start date and end date is same day */}
                        {new Date(eventDetailsData[0]?.fields?.startDate).toLocaleDateString('default', {
                          day: 'numeric',
                        }) ===
                          new Date(eventDetailsData[0]?.fields?.endDate).toLocaleDateString('default', {
                            day: 'numeric',
                          }) && <Paragraph content={formatDateSameDay()} />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-32">
                {eventDetailsData[0]?.fields?.onlineEventLink && (
                  <RenderButtonEvents
                    item={buttonDetails}
                    link={eventDetailsData[0]?.fields?.onlineEventLink}
                    target="_blank"
                  />
                )}
                {!eventDetailsData[0]?.fields?.onlineEventLink && (
                  <div onClick={(e) => handleForm(e, eventDetailsData[0]?.fields?.eventId)}>
                    <RenderButtonEvents item={buttonDetails} link="/" target="_self" type="submit" />
                  </div>
                )}
              </div>
            </div>
          )}
          {Object.keys(eventDetailsData[0]).length !== 0 && form !== '' && (
            <div id={form} className="evtForm" data-desc={eventDetailsData[0]?.fields?.eventDescription}>
              <Paragraph
                content={
                  eventDetailsData[0]?.fields?.locationAddress ? eventDetailsData[0]?.fields?.locationAddress : 'Online'
                }
                classes="hidden evtLocation"
              />
              <EventRegistrationForm eventData={evtDataForm} />
            </div>
          )}
          {Object.keys(eventDetailsData[0]).length === 0 && <Paragraph content={'No event available'} />}
        </div>
      </div>
      {moreDates.length > 0 && (
        <MoreEvents
          background="purple"
          cardBackground="white"
          border={true}
          columnLayout="3"
          content={moreDates}
          buttonDetails={buttonDetails}
          buttonCards={buttonCards}
        />
      )}
    </>
  )
}

export default EventDetails
